import { App } from "vue";
import * as Sentry from "@sentry/vue";
import router from "@/router";
import { BrowserTracing } from "@sentry/tracing";

export const initSentry = (app: App<Element>) => {
  router.beforeEach((to, from, next) => {
    Sentry.setUser({email: document.email, id: document.gid});
    Sentry.configureScope(function (scope) {
      scope.setTag("transaction_id", document.transactionId);
    });
    next()
  });

  router.afterEach((to, from) => {
    if (to.meta != null && to.meta.title) {
      Sentry.configureScope(scope => to.meta != null && scope.setTransactionName(to.name?.toString()));
    }
  });

  Sentry.init({
    app,
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENV,
    release: process.env.SENTRY_VERSION,
    autoSessionTracking: true,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router), 
        tracingOrigins: ["localhost", /^\//],
      }),
    ],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.1,
    logErrors: true,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.'],
    tracingOptions: {
      trackComponents: true,
    },
  });
}
